exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ninput.mobile-input[data-v-478f10f6] {\n  width: 100%;\n  border-bottom: grey 1px solid;\n  color: grey;\n  border-left: none;\n  border-right: none;\n  border-top: none;\n}\n", ""]);

// exports
